// const PRICE_GAP = 501;

// function initPriceRangeSlider() {
//   const minRange = document.querySelector('.main-collection-2__price-range-slider-min-range');
//   const maxRange = document.querySelector('.main-collection-2__price-range-slider-max-range');
//   const progress = document.querySelector('.price-slider-progress');
//   const minInput = document.querySelector('.min-input');
//   const maxInput = document.querySelector('.max-input');
//   const minInputTxt = document.querySelector('.main-collection-2__price-range-price-field-min-text');
//   const maxInputTxt = document.querySelector('.main-collection-2__price-range-price-field--max-text');

//   if (
//     !minRange ||
//     !maxRange ||
//     !progress ||
//     !minInput ||
//     !maxInput
//   ) {
//     return;
//   }

//   if (minRange.dataset.initialized === 'true') {
//     return;
//   }

//   async function fetchMinPrice() {
//     const response = await fetchPrice("price-ascending", "main-collection-2-min-price-ajax", "min_price")
//     const minRange = document.querySelector('.main-collection-2__price-range-slider-min-range');
//     const maxRange = document.querySelector('.main-collection-2__price-range-slider-max-range');
//     const minInput = document.querySelector('.min-input');

//     minRange.value = response;
//     minRange.min = response;
//     maxRange.min = response;
//     console.log(minRange.value);
//     // maxRange.min = response;

//     minInput.value = response;
//     console.log(minRange, minInput, "priceRangeMin");
//     minRange.dispatchEvent(
//     new Event("input", { bubbles: true })
//   );
//   }

//   function getURL(sortBy, sectionId) {
//     const url = new URL(window.location.href);
    
//     url.searchParams.delete("filter.v.price.gte");
//     url.searchParams.delete("filter.v.price.lte");

//     url.searchParams.set("sort_by", sortBy);
//     url.searchParams.set("section_id", sectionId);

//     return url;
//   }

//   async function fetchPrice(sortType, sectionId, key) {
//     const url = getURL(sortType, sectionId);

//     const html = await fetch(`${url.pathname}${url.search}`)
//       .then(res => res.text());

//     const parsedHTML = new DOMParser().parseFromString(html, "text/html");
//     const scriptEl = parsedHTML.querySelector("script");

//     if (!scriptEl?.textContent) return null;

//     const data = JSON.parse(scriptEl.textContent);

//     return data[key] ? Number(data[key]) / 100 : null;
//   }

//   if (minRange.dataset.initialized != 'true'){
//     fetchMinPrice();
//   }

//   minRange.dataset.initialized = 'true';
//   maxRange.dataset.initialized = 'true';
  
//   const updateProgress = (event) => {
//     if (event?.type == "main-collection-2:price-range:update-progress"){
//       minRange.classList.remove("main-collection-2__input--loading");
//       maxRange.classList.remove("main-collection-2__input--loading");
//     }
//     const min = Number(minRange.value);
//     const max = Number(maxRange.value);
//     const rangeMin = Number(minRange.min);
//     const rangeMax = Number(minRange.max);
//     const range = rangeMax - rangeMin;

//     const left = ((min - rangeMin) / range) * 100;
//     const right = ((rangeMax - max) / range) * 100;

//     progress.style.left = `${left}%`;
//     progress.style.right = `${right}%`;
//   };

//   function formatIndianNumber(num) {
//     const value = Number(num);
//     if (isNaN(value)) return '';
//     return value.toLocaleString('en-IN');
//   }

//   const syncInputs = (event) => {
//     minInput.value = minRange.value;
//     maxInput.value = maxRange.value;
//     minInputTxt.textContent = `₹${formatIndianNumber(minRange.value)}`;
//     maxInputTxt.textContent = `₹${formatIndianNumber(maxInput.value)}`;
//   };

//   const reset = () => {
//     minRange.value = minRange.min;
//     maxRange.value = maxRange.max;

//     syncInputs();
//     updateProgress();
//   };

//   minRange.addEventListener('input', () => {
//     const min = Number(minRange.value);
//     const max = Number(maxRange.value);

//     if (max - min < PRICE_GAP) {
//       minRange.value = max - PRICE_GAP;
//     }

//     syncInputs();
//     updateProgress("max");
//   });

//   maxRange.addEventListener('input', () => {
//     const min = Number(minRange.value);
//     const max = Number(maxRange.value);

//     if (max - min < PRICE_GAP) {
//       maxRange.value = min + PRICE_GAP;
//     }

//     syncInputs();
//     updateProgress("min");
//   });

//   minRange.addEventListener('change', syncInputs);
//   maxRange.addEventListener('change', syncInputs);

//   document.addEventListener(
//     'main-collection-2:price-range:update-progress',
//     updateProgress
//   );

//   document.addEventListener(
//     'main-collection-2:price-range:clear',
//     reset
//   );

//   updateProgress();
// }

// document.addEventListener('DOMContentLoaded', initPriceRangeSlider);
const PRICE_GAP = 501;

function initPriceRangeSlider() {
  let minRange = document.querySelector(
    '.main-collection-2__price-range-slider-min-range'
  );

  const maxRange = document.querySelector(
    '.main-collection-2__price-range-slider-max-range'
  );

  const progress = document.querySelector('.price-slider-progress');
  const minInput = document.querySelector('.min-input');
  const maxInput = document.querySelector('.max-input');

  const minInputTxt = document.querySelector(
    '.main-collection-2__price-range-price-field-min-text'
  );

  const maxInputTxt = document.querySelector(
    '.main-collection-2__price-range-price-field--max-text'
  );

  if (
    !minRange ||
    !maxRange ||
    !progress ||
    !minInput ||
    !maxInput
  ) {
    return;
  }

  if (minRange.dataset.initialized === 'true') {
    return;
  }

  function formatIndianNumber(num) {
    const value = Number(num);

    if (isNaN(value)) return '';

    return value.toLocaleString('en-IN');
  }

  function syncInputs() {
    minInput.value = minRange.value;
    maxInput.value = maxRange.value;

    minInputTxt.textContent =
      `₹${formatIndianNumber(minRange.value)}`;

    maxInputTxt.textContent =
      `₹${formatIndianNumber(maxRange.value)}`;
  }

  function updateProgress(event) {
    if (
      event?.type ===
      'main-collection-2:price-range:update-progress'
    ) {
      minRange.classList.remove(
        'main-collection-2__input--loading'
      );

      maxRange.classList.remove(
        'main-collection-2__input--loading'
      );
    }

    const min = Number(minRange.value);
    const max = Number(maxRange.value);

    const rangeMin = Number(minRange.min);
    const rangeMax = Number(minRange.max);

    const range = rangeMax - rangeMin;

    if (range <= 0) return;

    const left =
      ((min - rangeMin) / range) * 100;

    const right =
      ((rangeMax - max) / range) * 100;

    progress.style.left = `${left}%`;
    progress.style.right = `${right}%`;
  }

  function handleMinInput() {
    const min = Number(minRange.value);
    const max = Number(maxRange.value);

    if (max - min < PRICE_GAP) {
      minRange.value = max - PRICE_GAP;
    }

    syncInputs();
    updateProgress();
  }

  function handleMaxInput() {
    const min = Number(minRange.value);
    const max = Number(maxRange.value);

    if (max - min < PRICE_GAP) {
      maxRange.value = min + PRICE_GAP;
    }

    syncInputs();
    updateProgress();
  }

  // Attach listeners to the current min range
  function attachMinRange() {
    minRange.addEventListener(
      'input',
      handleMinInput
    );

    minRange.addEventListener(
      'change',
      syncInputs
    );
  }

  maxRange.addEventListener(
    'input',
    handleMaxInput
  );

  maxRange.addEventListener(
    'change',
    syncInputs
  );

  attachMinRange();

  async function fetchMinPrice() {
    const response = await fetchPrice(
      'price-ascending',
      'main-collection-2-min-price-ajax',
      'min_price'
    );

    if (response == null) return;

    // Clone the CURRENT element
    const newMinRange = minRange.cloneNode(true);

    // Update the new element
    newMinRange.min = String(response);
    newMinRange.value = String(response);

    // Replace old DOM node
    minRange.replaceWith(newMinRange);

    // IMPORTANT:
    // Point minRange to the NEW element
    minRange = newMinRange;

    // Update the other elements
    maxRange.min = String(response);
    minInput.value = String(response);

    // Reattach listeners because cloneNode
    // does NOT copy addEventListener listeners
    attachMinRange();

    // Directly update UI — no dispatchEvent
    syncInputs();
    updateProgress();

    console.log('NEW MIN RANGE:', minRange);
  }

  async function fetchPrice(sortType, sectionId, key) {
    const url = new URL(window.location.href);

    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');

    url.searchParams.set('sort_by', sortType);
    url.searchParams.set('section_id', sectionId);

    const html = await fetch(
      `${url.pathname}${url.search}`
    ).then(res => res.text());

    const parsedHTML = new DOMParser()
      .parseFromString(html, 'text/html');

    const scriptEl =
      parsedHTML.querySelector('script');

    if (!scriptEl?.textContent) {
      return null;
    }

    const data =
      JSON.parse(scriptEl.textContent);

    return data[key]
      ? Number(data[key]) / 100
      : null;
  }

  function reset() {
    minRange.value = minRange.min;
    maxRange.value = maxRange.max;

    syncInputs();
    updateProgress();
  }

  document.addEventListener(
    'main-collection-2:price-range:update-progress',
    updateProgress
  );

  document.addEventListener(
    'main-collection-2:price-range:clear',
    reset
  );

  minRange.dataset.initialized = 'true';
  maxRange.dataset.initialized = 'true';

  syncInputs();
  updateProgress();

  fetchMinPrice();
}

document.addEventListener(
  'DOMContentLoaded',
  initPriceRangeSlider
);